import { Suspense, lazy } from 'react';
import PageLoader from 'components/PageLoader';
import { AppRouteComponentProps } from 'components/AppRoutes';

const FeedbackRequestDetailComponent = lazy(
  () => import('./FeedbackRequestDetail.component'),
);

export default function FeedbackRequestDetail(props: AppRouteComponentProps) {
  return (
    <Suspense fallback={<PageLoader open />}>
      <FeedbackRequestDetailComponent {...props} />
    </Suspense>
  );
}
